/* VENDORED — DO NOT EDIT BY HAND. See scripts/vendor-manifest.mjs.
   source:  andavo-dev libs/client/web/shared/ui/nomad/src/lib/Textarea/Textarea.tsx
   commit:  b875130356
   repoint: this file maps to @andavo/* at merge into andavo-dev.
 */
import { cn } from '../../../util/cn';
import * as React from 'react';

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        'flex min-h-[80px] w-full rounded-sm border border-border-medium bg-surface-midground px-3 py-2 font-inter text-base placeholder:text-primary-disabled focus-visible:outline focus-visible:outline-2 focus-visible:outline-border-action focus-visible:-outline-offset-2 disabled:cursor-not-allowed disabled:opacity-50 sm:text-sm',
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = 'Textarea';

export { Textarea };
